<svg:polyline [attr.points]="pointsString$ | async" />
